import { useCallback, useContext, useEffect } from 'react';

import { PREVIEW_ERROR_STATUS, TemplateRequestStatus } from '../../../FormChangeHistory.constants';
import { FormTemplateRequestsContext } from '../../../FormChangeHistory.context';
import useTemplateRequest from '../../../hooks/useTemplateRequest';
import { loadPreviewDocument, releasePreviewDocument } from '../PagedTemplatePreview.utils';

/**
 * One preview pane's pages, read when the pane has a template: a side without one says so unread.
 * The pdf.js document is released when the pane reads another or unmounts, and so is one that
 * finishes loading after that.
 */
const usePreviewDocument = ({ auditId, pane, templateKind }) => {
  const requests = useContext(FormTemplateRequestsContext);

  const load = useCallback(
    () => loadPreviewDocument({ requests, auditId, side: pane.side, templateKind }),
    [requests, auditId, pane.side, templateKind],
  );

  const { status, data, retry } = useTemplateRequest(
    pane.hasDocument ? load : null,
    0,
    PREVIEW_ERROR_STATUS,
    releasePreviewDocument,
  );

  useEffect(() => () => releasePreviewDocument(data), [data]);

  return {
    status: pane.hasDocument ? status : TemplateRequestStatus.NO_DOCUMENT,
    document: data,
    retry,
  };
};

export default usePreviewDocument;
